// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8737606b","729":"1f8bf8ce"}[chunkId] + ".chunk.js";
};